import React from 'react'
import BoxContainer from './BoxContainer'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import launchProgramsWordings from '../../Shared/wordings.json'
import { ReactComponent as SuccessIcon } from './success-icon.svg'
import styled from 'styled-components'

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
`

const SuccessIconStyled = styled(SuccessIcon)`
  width: 1.25rem;
  height: 1.25rem;
  color: ${(props) => props.theme.palette.success.green500};
`

const SetupCompleteBox = () => {
  return (
    <BoxContainer>
      <TitleContainer>
        <SuccessIconStyled />
        <Text variant='h5'>{launchProgramsWordings.successBox.title}</Text>
      </TitleContainer>
      <Text variant='action4' color={palette.text.secondary}>
        {launchProgramsWordings.successBox.description}
      </Text>
    </BoxContainer>
  )
}

export default SetupCompleteBox
